import { showErrorToast, showSuccessToast } from "@/components/ui/toast";
import {
  createWorkSession,
  deleteWorkSession,
  getWorkSessions,
  updateWorkSession,
} from "@/services/workSession.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// Récupérer les sessions de travail
export const useFetchWorkSessions = (
  params?: {
    userId?: string;
    companyId?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
    groupBy?: string;
    search?: string;
    active?: boolean;
    hasComment?: boolean;
    isReviewed?: boolean;
  },
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["workSessions", params], // params est l'objet contenant les paramètres de la requête
    queryFn: () => getWorkSessions(params), // getWorkSessions est la fonction qui récupère les sessions de travail
    enabled: options?.enabled ?? true,
  });
};

//Modifier une session de travail
export const useUpdateWorkSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      sessionId,
      data,
    }: {
      sessionId: string;
      data: {
        startTime?: string;
        endTime?: string | null;
        duration?: number | null;
        isReviewed?: boolean;
      };
    }) => updateWorkSession(sessionId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workSessions"] });
    },
    onError: (error) => {
      showErrorToast(
        error instanceof Error ? error.message : "Une erreur est survenue"
      );
    },
  });
};

// Créer une session de travail manuellement
export const useCreateWorkSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      employeeId: string;
      startTime: string;
      endTime?: string | null;
      companyId?: string;
    }) => createWorkSession(data),
    onSuccess: () => {
      showSuccessToast("Session de travail créée avec succès");
      queryClient.invalidateQueries({ queryKey: ["workSessions"] });
    },
    onError: (error) => {
      showErrorToast(
        error instanceof Error ? error.message : "Une erreur est survenue"
      );
    },
  });
};

// Hook pour delete un worksession
export const useDeleteWorkSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteWorkSession,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workSessions"] });
      showSuccessToast("La session de travail a bien été supprimée");
    },
    onError: (error) => {
      showErrorToast(
        error instanceof Error
          ? error.message
          : "Une erreur est survenue lors de la suppression de la session de travail"
      );
    },
    // onError: () => {
    //   showErrorToast()
    // }
  });
};
